import React from 'react'
import LoadActiveCourse from './LoadActiveCourse'
import LoadStudentProfileTool from './LoadStudentProfileTool'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

/**
 * This component will check whether you are a content editor or a normal user
 * and provide a different way to load data for MyVU.
 *
 * Content editors must manually provide:
 *   - Cohort
 *   - College
 *   - Calendar type
 *   - Enrolment status
 *
 * Normal users will have their data automatically pulled in from Callista.
 */

const mapStateToProps = ({ currentUser }) => {
  return {
    userRole: currentUser.data['role']
  }
}

class CourseCheckpoint extends React.Component {
  render() {
    if (this.props.userRole == 'EDITOR' || this.props.userRole == 'REVIEWER') {
      // Display a form to content editors to allow them compose a student
      // profile that the content editor wishes to test.
      return (
        <LoadStudentProfileTool>{this.props.children}</LoadStudentProfileTool>
      )
    }

    // MyVU will attempt to load a user's course from Callista if they are a
    // normal user.
    return <LoadActiveCourse>{this.props.children}</LoadActiveCourse>
  }
}

export default withRouter(connect(mapStateToProps)(CourseCheckpoint))
